<template>
  <div class="chat-posts-flex-container">
    <div class="posts-flex-item">
      <div class="posts-wrapper" ref="postsWrapper">
        <div
          v-for="groupChatPost in groupChatPosts"
          :key="groupChatPost.id"
          @mouseover="() => { if (editPostId != groupChatPost.id) activePostId = groupChatPost.id }"
          @mouseleave="activePostId = null; reactionPostId = null;"
          :class="['post', {
            'active': activePostId == groupChatPost.id && editPostId != groupChatPost.id,
            'new': newPostId == groupChatPost.id
          }]"
        >
          <div
            v-if="activePostId == groupChatPost.id && editPostId != groupChatPost.id"
            class="post-items"
            v-click-outside="() => reactionPostId = false"
          >
            <proa-tool-icon
              :src="require('@/assets/images/chat_tool_icons/reaction.png')"
              @click.native="reactionPostId = groupChatPost.id"
            />
            <!-- NOTE: スレッド機能は保留 -->
            <!-- <proa-tool-icon :src="require('@/assets/images/chat_tool_icons/thread.png')"/> -->
            <proa-tool-icon
              v-if="groupChatPost.userId == signedInUser.id"
              :src="require('@/assets/images/chat_tool_icons/edit.png')"
              @click.native="preUodatePostsWrapperRenderingKey(() => { editPostId = groupChatPost.id })"
            />
            <proa-tool-icon
              v-if="groupChatPost.userId == signedInUser.id"
              :src="require('@/assets/images/chat_tool_icons/trash.png')"
              @click.native="onClickDeleteGroupChatPost(groupChatPost)"
            />
            <div v-if="reactionPostId == groupChatPost.id" class="reaction-items-wrapper">
              <div class="reaction-items">
                <div
                  v-for="reaction in reactions"
                  :key="reaction.id"
                  @click="onClickReaction(reaction.id)"
                  class="reaction-item"
                >
                  <proa-tool-icon
                    :src="reaction.reactionImage.url"
                  />
                </div>
              </div>
            </div>
          </div>
          <group-chat-post-content
            :contentBindKey="`${postsWrapperRenderingKey}-${groupChatPost.id}`"
            :groupChat="groupChat"
            :groupChatPost="groupChatPost"
            :editing="editPostId == groupChatPost.id"
            @onMouseOverChatPostItem="activePostId = null"
            @onCancelEditChatPost="preUodatePostsWrapperRenderingKey(() => { editPostId = null })"
            @onClickNewAttachment="(groupChatPost) => onClickNewAttachment(groupChatPost)"
            @onClickRemoveAttachment="(index) => onClickRemoveAttachment({
              groupChatPost: groupChatPost,
              index: index
            })"
            @onSubmitChatPost="onUpdateChatPost"
            @toggleAttachmentModal="togglePostsWrapperStyle"
          />
        </div>
        <div class="post-loading blink"
          v-if="pagination.next"
          ref="postLoading"
        >
          {{ $t('common.postLoading') }}
        </div>
      </div>
    </div>
    <div v-if="newGroupChatPost" class="edit-flex-item">
      <group-chat-post-editor
        :groupChat="groupChat"
        :groupChatPost="newGroupChatPost"
        :groupChatPostRenderingKey="newGroupChatPostRenderingKey"
        @onClickNewAttachment="onClickNewAttachment"
        @onClickRemoveAttachment="(index) => onClickRemoveAttachment({
          groupChatPost: newGroupChatPost,
          index: index
        })"
        @onSubmitChatPost="onSubmitChatPost"
      />
    </div>
    <proa-modal
      :modal="deletingGroupChatPost != null"
      :title="$t('common.confirm')"
      @close="deletingGroupChatPost = null"
    >
      <proa-heading sub>{{ $t('common.modals.deleteChatPostModal.confirmMessage') }}</proa-heading>
      <group-chat-post-content
        :groupChatPost="deletingGroupChatPost"
        class="my-4"
        preview
      />
      <template v-slot:footer>
        <proa-button
          @click.native="deletingGroupChatPost = null"
          class="mr-2"
        >
          {{ $t('common.cancel') }}
        </proa-button>
        <proa-button
          @click.native="onConfirmedDeleteGroupChatPost(deletingGroupChatPost.id)"
          variant="secondary"
        >
          {{ $t('common.delete') }}
        </proa-button>
      </template>
    </proa-modal>
    <attachment-file-size-limit-error-modal
      :fileNames="attachmentFileSizeLimitErrorFileNames"
      @close="attachmentFileSizeLimitErrorFileNames = []"
    />
  </div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'
import ClickOutside from 'vue-click-outside'
import Reaction from '@/store/models/Reaction'
import GroupChatPost from '@/store/models/GroupChatPost'
import VirtualInputFile from '@/lib/VirtualInputFile'

import AttachmentFileSizeLimitErrorModal from '@/components/organisms/AttachmentFileSizeLimitErrorModal'
import GroupChatPostContent from '@/components/organisms/GroupChatPostContent'
import GroupChatPostEditor from '@/components/organisms/GroupChatPostEditor'

export default {
  name: 'GroupChatPostsContainer',
  components: {
    AttachmentFileSizeLimitErrorModal,
    GroupChatPostContent,
    GroupChatPostEditor
  },
  directives: {
    ClickOutside
  },
  props: {
    groupChat: Object
  },
  computed: {
    reactions: function() {
      return Reaction.query().orderBy('sequenceNo').get()
    },
    groupChatPosts: function() {
      return GroupChatPost.query().where('groupChatId', this.currentGroupChatId).orderBy('createdAt', 'desc').get()
    },
    ...mapGetters({
      httpError: 'httpError',
      signedInUser: 'auth/signedInUser',
      updatedViaChannel: 'channels/updatedViaChannel',
      pagination: 'entities/groupChatPosts/pagination'
    })
  },
  data(){
    return {
      creatSequence: false,
      attachmentFileSizeLimitErrorFileNames: [],
      currentGroupChatId: null,
      activePostId: null,
      newPostId: null,
      editPostId: null,
      reactionPostId: null,
      isLoading: false,
      deletingGroupChatPost: null,
      newGroupChatPost: null,
      newGroupChatPostRenderingKey: 0,
      postsWrapperRenderingKey: 0
    }
  },
  methods: {
    async initContainer(groupChatId) {
      this.currentGroupChatId = groupChatId
      this.newGroupChatPost = GroupChatPost.skeleton()
      GroupChatPost.deleteAll()
      await this.apiGetGroupChatPosts({
        groupChatId: groupChatId
      })
      this.$refs.postsWrapper.removeEventListener('scroll', this.onScrollPostsWrapper)
      this.$refs.postsWrapper.addEventListener('scroll', this.onScrollPostsWrapper)
    },
    async onScrollPostsWrapper() {
      if (!this.$refs.postLoading || this.isLoading) return
      if (Math.abs(this.$refs.postsWrapper.scrollTop - this.$refs.postLoading.offsetTop) < 20) {
        this.isLoading = true
        await this.apiGetGroupChatPosts({
          groupChatId: this.currentGroupChatId,
          page: this.pagination.next
        })
        this.isLoading = false
        this.preUodatePostsWrapperRenderingKey()
      }
    },
    async onClickReaction(reactionId) {
      const reactionPost = GroupChatPost.find(this.reactionPostId)
      const reactedReaction = reactionPost.groupChatReactions.find(groupChatReaction => {
        return groupChatReaction.reactionId == reactionId
               && groupChatReaction.userId == this.signedInUser.id
      })
      if (reactedReaction) {
        await this.apiDeleteGroupChatPostReactions({
          groupChatId: this.currentGroupChatId,
          groupChatPostId: this.reactionPostId,
          id: reactedReaction.id
        })
      } else {
        await this.apiPostGroupChatPostReactions({
          groupChatId: this.currentGroupChatId,
          groupChatPostId: this.reactionPostId,
          attributes: {
            reactionId: reactionId
          }
        })
      }
      this.reactionPostId = null
    },
    onClickNewAttachment: function(groupChatPost) {
      const virtualInputFile = new VirtualInputFile({
        multiple: true
      })

      virtualInputFile.on('fileSizeLimitError', (fileName) => {
        this.attachmentFileSizeLimitErrorFileNames.push(fileName)
      })

      virtualInputFile.on('fileRead', (file) => {
        if (groupChatPost) {
          groupChatPost.groupChatAttachmentsAttributes.push({
            attachmentFileName: file.name,
            attachmentFile: file.base64Data
          })
          this.preUodatePostsWrapperRenderingKey()
        } else {
          this.newGroupChatPost.groupChatAttachmentsAttributes.push({
            attachmentFileName: file.name,
            attachmentFile: file.base64Data
          })
        }
      })
    },
    onClickRemoveAttachment: function(args) {
      const { groupChatPost, index } = args
      if (!groupChatPost.id) {
        this.newGroupChatPost.groupChatAttachmentsAttributes.splice(index, 1)
      } else {
        if (groupChatPost.groupChatAttachmentsAttributes[index].id) {
          groupChatPost.groupChatAttachmentsAttributes.splice(index, 1, {
            ...groupChatPost.groupChatAttachmentsAttributes[index],
            _destroy: true
          })
        } else {
          groupChatPost.groupChatAttachmentsAttributes.splice(index, 1)
        }
        this.preUodatePostsWrapperRenderingKey()
      }
    },
    async onSubmitChatPost() {
      await this.apiPostGroupChatPosts({
        groupChatId: this.currentGroupChatId,
        attributes: this.newGroupChatPost
      })

      if (!this.httpError) {
        this.newPostId = this.groupChatPosts[0].id
        this.$refs.postsWrapper.scrollTop = 0
        this.newGroupChatPost = GroupChatPost.skeleton()
      }
    },
    async onUpdateChatPost(groupChatPost) {
      await this.apiPutGroupChatPosts({
        groupChatId: this.currentGroupChatId,
        attributes: groupChatPost
      })

      if (!this.httpError) {
        this.editPostId = null
      }
    },
    onClickDeleteGroupChatPost(groupChatPost) {
      this.deletingGroupChatPost = groupChatPost
    },
    async onConfirmedDeleteGroupChatPost(id) {
      await this.apiDeleteGroupChatPosts({
        groupChatId: this.currentGroupChatId,
        id: id
      })
      if (!this.httpError) {
        this.deletingGroupChatPost = null
        this.apiReloadCurrentGroupChatPosts(this.currentGroupChatId)
      }
    },
    togglePostsWrapperStyle: function(isOpeningAttachmentModal) {
      if (isOpeningAttachmentModal) {
        this.$refs.postsWrapper.style.overflowY = 'hidden'
      } else {
        this.$refs.postsWrapper.style.overflowY = 'auto'
      }
    },
    preUodatePostsWrapperRenderingKey: function(callback) {
      ++this.postsWrapperRenderingKey
      this.$nextTick(() => {
        if (callback) callback()
      })
    },
    ...mapActions({
      apiGetGroupChatPosts: 'entities/groupChatPosts/index',
      apiPostGroupChatPosts: 'entities/groupChatPosts/create',
      apiPutGroupChatPosts: 'entities/groupChatPosts/moduleUpdate',
      apiDeleteGroupChatPosts: 'entities/groupChatPosts/destroy',
      apiPostGroupChatPostReactions: 'groupChatPostReactions/create',
      apiDeleteGroupChatPostReactions: 'groupChatPostReactions/destroy',
      apiDeleteCurrentGroupChatId: 'entities/groupChatPosts/deleteCurrentGroupChatId',
      apiReloadCurrentGroupChatPosts: 'entities/groupChatPosts/reloadCurrentIndex'
    })
  },
  beforeDestroy() {
    this.apiDeleteCurrentGroupChatId()
    this.$refs.postsWrapper.removeEventListener('scroll', this.onScrollPostsWrapper)
  },
  created() {
    this.creatSequence = true
    this.initContainer(this.groupChat.id)
  },
  watch: {
    updatedViaChannel: function(value) {
      if (!value) return
      if (value?.type === 'groupChat' && value?.id == this.groupChat.id) {
        this.preUodatePostsWrapperRenderingKey()
      }
    },
    editPostId: function(_, oldId) {
      if (!oldId) return
      GroupChatPost.rollbackAttachmentsById(oldId)
    },
    groupChat: function(value) {
      if (this.creatSequence) {
        this.creatSequence = false
        return
      }
      this.newPostId = null

      if (this.currentGroupChatId != value.id) {
        this.initContainer(value.id)
      }
    },
    newGroupChatPost: function() {
      ++this.newGroupChatPostRenderingKey
    }
  }
}
</script>

<style scoped lang="scss">
</style>
